<mat-card class="pfi-selector-card">
  <mat-icon class="pfi-selector-icon">description</mat-icon>
  <div class="pfi-selector-copy">
    <span class="pfi-selector-title">PFI Value Sheet</span>
    <span class="pfi-selector-subtitle">Select an account and proforma</span>
  </div>
  <mat-form-field appearance="outline" class="pfi-select">
    <mat-label>Account number - PFI number</mat-label>
    <mat-select (selectionChange)="onPfiChange.emit($event.value)"
                [(ngModel)]="selectedPfi"
                [compareWith]="pfiCompareFn"
                [ngModelOptions]="{standalone: true}"
                [disabled]="isLoading">
      <mat-option *ngFor="let pfi of pfiList" [value]="pfi">
        {{ getPfiLabel(pfi) }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <button mat-icon-button class="pfi-refresh-btn" (click)="refreshPfiData()" matTooltip="Refresh PFI value sheets" type="button">
    <mat-icon>refresh</mat-icon>
  </button>
</mat-card>
